import { render, staticRenderFns } from "./news-card.vue?vue&type=template&id=4d48aca6"
import script from "./news-card.vue?vue&type=script&lang=js"
export * from "./news-card.vue?vue&type=script&lang=js"
import style0 from "./news-card.vue?vue&type=style&index=0&id=4d48aca6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports